import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

@Injectable()
export class SeedService {
  lastSeeds: any = {};
  curSeeds: any = {
    rndNrMethod: 'moz',
    clSeed: '',
    hashedServerSeed: '',
    srvSeed: '',
    gameId: '',
  };
  seedNote = '';

  constructor(private http: Http) {
  }

  create(): Observable<string> {
    return Observable.fromPromise(new Promise((resolve, reject) => {
      let newRndNr = '';
      if (this.curSeeds.rndNrMethod === 'moz') {
        const rndNs = new Uint32Array(8);
        const cryptoObj = window.crypto || (window as any).msCrypto; // for IE 11
        cryptoObj.getRandomValues(rndNs);
        for (let i = 0; i < rndNs.length; i++) {
          const str = rndNs[i].toString(16);
          newRndNr += '00000000'.slice(str.length) + str;
        }
        this.curSeeds.clSeed = '0x' + newRndNr;
        return resolve(this.curSeeds.clSeed);
      } else if (this.curSeeds.rndNrMethod === 'rndOrg') {
        const url = 'https://www.random.org/cgi-bin/randbyte?nbytes=32&format=h';
        this.http.get(url).toPromise().then((response) => {
          const data = response.text()
            .replace(/ /g, '')
            .replace(/\n/g, '');
          const re = /^[0-9A-Fa-f]*$/g;
          if (re.test(data)) {
            newRndNr = data;
          }
          this.curSeeds.clSeed = '0x' + newRndNr;
          return resolve(this.curSeeds.clSeed);
        });
      } else {
        return resolve(this.curSeeds.clSeed);
      }
    }));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/seed.service.ts